import React from "react";

let currencyFormatterWithoutCents = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", minimumFractionDigits: 0, maximumFractionDigits: 0 });
let currencyFormatterPrecision = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", minimumFractionDigits: process.env.REACT_APP_PRECISION});
let currencyFormatterUSD = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
let percentFormatter = new Intl.NumberFormat("pt-BR", { style: "percent" });
let percentPrecisionFormatter = new Intl.NumberFormat("pt-BR", { style: "percent" , minimumFractionDigits: 2});
let decimalFormatter = new Intl.NumberFormat("pt-BR");
let fixexFormatter = new Intl.NumberFormat("pt-BR", { minimumFractionDigits: 1 });
let dateFormatter = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" });
let timestampFormatter = new Intl.DateTimeFormat("pt-BR", { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" });
const ptBR_numberFormat = new Intl.NumberFormat("pt-BR");

export function toCurrency(value, minimumFractionDigits = 2) {
	return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", minimumFractionDigits}).format(Number(value || 0));
}

export function toNumberRightAligned(value) {
	return <div style={{textAlign: "right"}}>{ptBR_numberFormat.format(value)}</div>;
}

export function toCurrencyRightAligned(value) {
	return <div style={{textAlign: "right"}}>{toCurrency(value)}</div>;
}

export function toCurrencyWithoutCents(value) {
	return currencyFormatterWithoutCents.format(value);
}

export function toCurrencyFormatterPrecision(value) {
	return currencyFormatterPrecision.format(value);
}

export function toCurrencyUSD(value) {
	return currencyFormatterUSD.format(value);
}

export function toDecimal(value) {
	return decimalFormatter.format(value);
}

export function toDecimalMathRound(value) {
	return decimalFormatter.format(Math.round(value));
}

export function toDecimalMathRoundNull(value) {
	if (value)
		return decimalFormatter.format(Math.round(value));
	else 
		return 0;
}

export function toDecimalFixed(value, dp) {
	return fixexFormatter.format(value.toFixed(dp));
}

export function toDate(value) {
	return dateFormatter.format(Date.parse(value));
}

export function toTimestamp(value) {
	return timestampFormatter.format(value);
}

export function toPercent(value) {
	return percentFormatter.format(value);
}

export function toPercentPrecision(value) {
	return percentPrecisionFormatter.format(value);
}

export function toPercentFull(value) {
	return new Intl.NumberFormat("pt-BR", { style: "percent", minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
}

export function formatValue(value, type = "decimal") {
	if (type === "currency") {
		return toCurrency(value);
	} else if (type === "currencyWithoutCents") {
		return toCurrencyWithoutCents(value);	
	} else {
		return toDecimalMathRoundNull(value);
	}
}